const ManufacturerGLNStatus = {
  SUBMITTED: 'submitted',
  SUBSCRIBED: 'subscribed',
  SUCCESS: 'success',
  FAILED: 'failed',
};

export const ManufacturerGLNStatusOptions = [
  { value: ManufacturerGLNStatus.SUCCESS, label: 'Success' },
  { value: ManufacturerGLNStatus.SUBSCRIBED, label: 'Subscribed' },
  { value: ManufacturerGLNStatus.SUBMITTED, label: 'Submitted' },
  { value: ManufacturerGLNStatus.FAILED, label: 'Failed' },
];

export const DefaultSelectedGLNStatuses = [
  { value: ManufacturerGLNStatus.SUCCESS, label: 'Success' },
  { value: ManufacturerGLNStatus.SUBSCRIBED, label: 'Subscribed' },
];

export default ManufacturerGLNStatus;
